import React, { useEffect, useRef } from 'react';
import '../../Styles/css/animate.min.css';
import '../../Styles/css/bootstrap.css';
import '../../Styles/css/odometer.min.css';
import '../../Assests/icons/icomoon/style.css';
import progearAutomotive from '../../Assests/images/partners/progear-automotive.svg';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Worktogether = () => {
  const workRef = useRef(null);

  useEffect(() => {
    if (window.location.hash === '#we') {
      workRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);
  const textVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
    }),
  };
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  const text = "We collaborate with the best to deliver our best";
  const characters = text.split("");

  return (
    <section ref={workRef} id='we' className="section-work-together style-2 tf-spacing-1">
      <div className="wg-partner">
        <div className="tf-container container mb-48 gap-4 d-flex flex-column">

          <div className="heading-section text-center ">
            <div ref={ref} className="heading-section text-nowrap">
              <h2 className="title balance">
                {characters.map((char, i) => (
                  <motion.span
                    key={i}
                    className="inline-block"
                    variants={textVariants}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    custom={i}
                  >
                    {char}
                  </motion.span>
                ))}
              </h2>
            </div>
          </div>
          <div className="swiper brand-slide justify-content-center d-flex " >
            <div className=" svg1">
              <div className="partner-item style-2">
                <img
                  className="lazyload"
                  loading="lazy"
                  src={progearAutomotive}
                  alt="ProGear Automotive"
                />
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Worktogether;
